<template>
  <div>
    <!--div class="components_title">排放源清单管理</div-->
    <div
      :class="{ 'popup-type3': true, popupBar: true, historyTip: data.isHistory }"
      :style="{
        width: '500px',
        //height: '300px',
        background: data.isHistory ? 'intial' : '#001c19cc',
        position: 'absolute',
        padding: '30px 20px 20px 20px',
      }"
    >
      <div
        :style="{
          overflow: 'auto',
          zoom: '1',
          padding: '5px 0 15px 0',
          borderBottom: '1px solid #ccc',
        }"
      >
        <div class="popup-type1-title">微站-超标已处理</div>
        <div class="popup-type1-time">{{ data.createTime }}</div>
      </div>

      <div :style="{ padding: '10px 5px' }">
        <div :style="{ margin: '15px 0' }">
          设备地址: <span>{{ data.deviceName }}</span>
        </div>
        <div :style="{ margin: '20px 0' }">
          处理进度: <span class="success">已完成</span>
        </div>
        <div
          :style="{ margin: '20px 0', textAlign: 'center', overflow: 'auto', zoom: 1 }"
        >
          <div class="PM-box">
            <div class="PM-title">
              <span class="PM-name">PM2.5</span>
              <span class="PM-type">触发值</span>
            </div>
            <div class="PM-content">
              <span class="PM-val">{{ data.value }}</span>
              <span class="PM-unit">μg/m³</span>
            </div>
          </div>
          <img src="./img/arrow.png" :style="{ marginTop: '35px', display: 'inline' }" />
          <div class="PM-box" :style="{ float: 'right' }">
            <div class="PM-title" :style="{ background: '#36a994' }">
              <span class="PM-name">PM2.5</span>
              <span class="PM-type">触发值</span>
            </div>
            <div class="PM-content" :style="{ background: '#1d6460' }">
              <span class="PM-val">{{ data.handleValue }}</span>
              <span class="PM-unit">μg/m³</span>
            </div>
          </div>
        </div>
        <div style="height: 170px; margin: 10px">
          <el-steps
            class="stepModule"
            direction="vertical"
            :active="data.forwards.length"
            process-status="wait"
            finish-status="success"
          >
            <template v-for="(item, n) in data.forwards" v-bind:key="n">
              <!--el-step title="13:31:00" description="已完成"></el-step>
              <el-step title="13:40:34" description="周XX提交工单"></el-step>
              <el-step title="13:45:09" description="分配处理人周XX"></el-step>
              <el-step title="13:58:09" description="已通过PC、APP通知管理员"></el-step-->
              <el-step :title="item.createTime" :description="item.forward"></el-step>
            </template>
          </el-steps>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";

export default {
  components: {},
  props: ["data"],
  data() {
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
    };
  },
  mounted() {},
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  beforeUnmount() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.components_title {
  position: absolute !important;
  font-size: 24px;
  font-weight: bold;
}

.historyTip {
  // background:  url('./img/1.png') no-repeat;
  background-size: 100% 100%;
  //background: rgba(25, 45, 180, 0.5);
  border: 1px solid #fff;
  width: 500px;
  padding: "30px 20px 20px 20px";
  position: relative;
  pointer-events: auto;
  border-radius: 10px;
  font-size: 28px;
  background: rgba(90, 90, 90, 0.533);
  transform-origin: center center;
  color: #000;
  overflow: hidden;
  box-shadow: 7px 9px 6px #00000075;
  p {
    color: #2d2826;
    font-weight: bolder;
  }
}
.historyTip:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: -10%;
  width: 75%;
  height: 100%;
  background: white;
  opacity: 0.15;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
  -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
  transform: skew(-30deg) scaleY(1) translate(0, 0);
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.popup-type3 {
  position: relative;
  zoom: 1;
  overflow: auto;
}

.popup-type3:before {
  content: "";
  background: url(img/sk.png) no-repeat top;
  top: 10px;
  left: 20px;
  right: 20px;
  height: 50px;
  position: absolute;
}

.popup-type3:after {
  content: "";
  background: url(img/xk.png) no-repeat top;
  bottom: 10px;
  left: 20px;
  right: 20px;
  height: 50px;
  position: absolute;
}

.popup-type3-title {
  border: 2px solid #36a994;
  background: #1d6460;
  position: relative;
  margin-left: 0px;
  display: inline-block;
  border-radius: 15px;
  padding: 2px 10px;
  height: 40px;
  line-height: 32px;
  font-size: 22px;
  float: left;
}

.popup-type3-time {
  color: #93dbed;
  float: right;
  margin-right: 0px;
  padding: 0px 6px;
  font-size: 20px;
  line-height: 40px;
  height: 40px;
}

.success {
  color: #44d6b5;
}

.PM-box {
  position: relative;
  float: left;
  width: 150px;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 15px;
}

.PM-title {
  background: #c73e42;
  overflow: auto;
  zoom: 1;
}

.PM-name {
  height: 24px;
  float: left;
  line-height: 24px;
  font-size: 14px;
  padding-left: 10px;
}

.PM-type {
  height: 24px;
  float: right;
  line-height: 24px;
  font-size: 14px;
  padding-right: 10px;
}

.PM-content {
  background: #4b202c;
  height: 90px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  text-align: center;
  line-height: 90px;
}

.PM-val {
  font-size: 30px;
  font-weight: bolder;
  margin-right: 10px;
}

.PM-chart {
  width: 500px;
  height: 120px;
  position: relative;
  margin: 20px 30px 0px -30px;
}

.stepModule {
  width: 100%;
}

.stepModule .el-step {
  flex-basis: 90% !important;
}
</style>
<style>
.el-step__main > .el-step__title {
  display: inline-block !important;
  color: #5aaad8 !important;
  margin-right: 20px;
}

.el-step__main > .el-step__description {
  display: inline-block !important;
}
</style>
